module.exports = __webpack_public_path__ + "img/1.edb14864.jpg";